/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { actualizaResponsablePlataforma } from './plataformaAPI';
import { loadPlataformas } from './plataformaSlice';

// eslint-disable-next-line no-unused-vars, react/prop-types
export default function EditarResponsablePlataforma ({plataforma}) {
    const dispatch = useDispatch();
    const [showForm, setShowForm] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [ loadingStatus, setLoadingStatus ] = useState('');

    useEffect(() => {
        setLoadingStatus('');
    }, [inputValue]);
  
    function RequestStatus ({status}) {
        if (status === 'success') {
            return '';
        } else if (status === 'error') {
            return <div className='docstatus'>❌ No se puede ejecutar la acción.</div>;
        } else if (status === 'uploading'){
            return <div className='docstatus'>⏳ Comprobando...</div>;
        } else {
            return '';
        }
    }

    async function requestChange() {
        setLoadingStatus('uploading');
        const newEmail = inputValue;
        const data = { responsable: newEmail, nombre: plataforma };
        try {
            const response = await actualizaResponsablePlataforma(data);
            if (response.ok) {
                dispatch(loadPlataformas());
                setLoadingStatus('success');
                setInputValue('');
                setShowForm(false);
            } else {
                const body = await response.json();
                const e = body.message;
                throw new Error(e);
            }
        } catch (error) {
            setLoadingStatus('error');
            alert(error);
        }
    }
  
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (inputValue) {
            await requestChange();
        }
    };

    const handleButtonClick = ({target}) => {
        switch (target.id) {
        case 'cambiar':
            setShowForm(true);
            break;
        case 'cancelar':
            setShowForm(false);
            setInputValue('');
            setLoadingStatus('');
            break;
        default:
            break;
        }
        
    };

    return (
        <div>
            {!showForm ? (
                <button type="button" id="cambiar" onClick={handleButtonClick}>Cambiar</button>
            ) : (
                <form onSubmit={handleFormSubmit}>
                    <input
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                    />
                    <button type="submit">Guardar</button>
                    <button type="button" id="cancelar" onClick={handleButtonClick}>Cancelar</button>
                    <RequestStatus status={loadingStatus} />
                </form>
            )}
        </div>
    );
}